module.exports = __webpack_public_path__ + "static/media/KCC.12e4c4b0.svg";